import FaceValidationReleaseSettings from './FaceValidationReleaseSettings';
import FiscalChatVisibility from './FiscalChatVisibility';
import ConfigurationFormLayout, { ConfigurationSection } from '../ReusableComponents/ConfigurationFormLayout';
import FormFieldHelp from '../ReusableComponents/FormFieldHelp';
import ProcessConfigurationSummary from './ProcessConfigurationSummary';

import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, STORAGE_URL, URL } from '../../variables';
import { maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdReply, MdInfoOutline } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import JoditEditor from 'jodit-react';


import './label.css';
import { DatePicker, TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import 'moment/locale/pt-br';
import { alpha } from '@material-ui/core/styles'
import { FormControlLabel, Radio, TextField } from '@material-ui/core';
import { RadioGroup } from '@mui/material';

class EditarProcesso extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            path: '/',
            loading_screen: true,
            roles: [],
            name: '',
            regras: '',
            descricao: '',
            code:'',
            fim: moment().add(1, 'day'),
            hora_inicio: moment(),
            hora_fim: moment().add(1, 'hour'),

            loading_save: false,
            msgErro: '',
            loading_image: false,
            inicio: moment(),
            faculdade: { name: '', id: '' },
            fiscalizacoes: [
                { id: 'all', 'name': 'Salvar Vídeo e Imagem - Com streaming em tempo real' },
                { id: 'image', 'name': 'Salvar Apenas Imagem - Com streaming em tempo real' },
                { id: 'none', 'name': 'Salvar apenas logs - Sem streaming' },
            ],
            fiscalizacoes_simulado: [
                { id: 'all', 'name': 'Testar compartilhamento de câmera e áudio' },
                { id: 'none', 'name': 'Não compartilhar câmera e áudio' },
            ],
            fiscalizacao: 'all',

            chat_types: [
                { id: 'all', 'name': 'Ambos enviam mensagem' },
                { id: 'fiscal_to_student', 'name': 'Apenas o fiscal envia mensagem' },
                { id: 'none', 'name': 'Ninguem envia mensagem' },
            ],
            chat_type: 'all',
            show_fiscal_chat: true,

            times_save: [
                { id: '30000', 'name': '30 segundos' },
                { id: '15000', 'name': '15 segundos' },
            ],
            time_save: '30000',
            tempo_prova: '',
            type_time: 'all',
            online: true,
            full_screen:true,
            screen_extended_retrict:true,
            screen_sharing:false,
            required_camera_external:false,
            mobile:false,
            time_validation_periodicaly:40,
            chat_time:60,
            request_time:60,
            exam_per_time:false,
            restrict_access:false,
            face_validation: false,
            allow_face_validation_skip: false,
            face_validation_periodicaly:false,
            is_interview:false,
            inicio_access: moment().subtract('hour',24),
            fim_access: moment(),
            hora_inicio_access: moment().subtract('hour',24),
            hora_fim_access: moment(),
            simulado: false,
            show_rascunho: true,
            need_pause:false
        };

        this.config = {
            height: 300,
            // askBeforePasteHTML:false,
            // askBeforePasteFromWord:false,
            // defaultActionOnPaste:'insert_only_text',
            // defaultActionOnPasteFromWord:'insert_only_text',
            // pasteHTMLActionList:[
            //     { value: 'insert_only_text', text: 'Insert only Text' }
            // ],
            // pasteFromWordActionList:[
            //     { value: 'insert_only_text', text: 'Insert only Text' }
            // ],
            readonly: this.state.loading_image,
            language: 'pt_br',
            toolbarButtonSize: 'large',
            "buttons": "source,bold,italic,underline,strikethrough,eraser,superscript,subscript,ul,ol,indent,outdent,left,center,right,justify,font,fontsize,paragraph,classSpan,image,brush,,undo,redo,hr,link,symbol,table",
            uploader: {
                url: API_URL + 'faculdade/upload_image',  //your upload api url
                insertImageAsBase64URI: false, //not inster base64
                imagesExtensions: ['jpg', 'png', 'jpeg', 'gif'],
                headers: { "accept": `application/json`, 'Authorization': 'Bearer ' + localStorage.getItem('token') },
                filesVariableName: function (t) {
                    return 'imagem';
                }, //"files",
                withCredentials: false,
                pathVariableName: 'path',
                //   format: 'json',
                method: 'POST',
                prepareData: (formdata) => {
                    console.log(formdata)
                    this.setState({ loading_image: true });
                    return formdata;
                },
                isSuccess: (e) => {
                    console.log(e);

                    return 'Upload realizado com sucesso';
                },
                getMessage: (e) => {
                    console.log(e);

                    return e;
                },
                process: (resp) => { //success callback transfrom data to defaultHandlerSuccess use.it's up to you.
                    let files = [];
                    console.log(resp);
                    files.unshift(STORAGE_URL + resp.imagem);
                    this.setState({ loading_image: false });

                    return {
                        files: files,

                    };
                },
                error: (elem, e) => {
                    // elem.j.e.fire('errorMessage', e.message, 'error', 4000);

                    console.log(e);
                    console.log(elem);
                    console.log('Bearer ' + localStorage.getItem('token'));
                },
                defaultHandlerSuccess: function (resp, elem) { // `this` is the editor.
                    if (resp.files && resp.files.length) {
                        resp.files.forEach((filename, index) => { //edetor insertimg function
                            this.selection.insertImage(filename);
                        });
                    }

                    // debugger;

                },
                defaultHandlerError: (elem, e) => {
                    // elem.j.e.fire('errorMessage', e.message);
                    console.log(e);
                    console.log(elem);
                    this.setState({ loading_image: false });

                },
                //   contentType: function (e) {
                //     return (

                //       'application/x-www-form-urlencoded; charset=UTF-8'
                //     );
                //   },
            },
        }
    }

    get_processo(id) {

        if (this.state.loading_screen == false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${URL}api/faculdade/get_processo/${id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token'); localStorage.removeItem('user');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    this.setState({ redirect: true });

                    //   setTimeout(()=>{
                    //     this.get_processo();
                    //   });
                }
                else {
                    // this.props.mudarUser(resp.user);
                    this.setState({
                        loading_screen: false, faculdade: resp.processo.faculdade,
                        name: resp.processo.name,
                        code: resp.processo.code ?? '',

                        inicio: moment(resp.processo.inicio),
                        fim: moment(resp.processo.fim),
                        hora_inicio: moment(resp.processo.inicio),
                        hora_fim: moment(resp.processo.fim),
                        regras: resp.processo.regras,
                        descricao: resp.processo.descricao,
                        online: resp.processo.online,
                        need_pause: resp.processo.need_pause,
                        request_time: resp.processo.request_time/60,
                        chat_time: resp.processo.chat_time/60,
                        time_validation_periodicaly: resp.processo.time_validation_periodicaly,

                        restrict_access:resp.processo.restrict_access,
                        inicio_access:resp.processo.time_init_restrict==null?this.state.inicio_access:moment(resp.processo.time_init_restrict),
                        hora_inicio_access:resp.processo.time_init_restrict==null?this.state.hora_inicio_access:moment(resp.processo.time_init_restrict),

                        fim_access:resp.processo.time_end_restrict==null?this.state.fim_access:moment(resp.processo.time_end_restrict),
                        hora_fim_access:resp.processo.time_end_restrict==null?this.state.hora_fim_access:moment(resp.processo.time_end_restrict),


                        simulado: resp.processo.simulado,
                        exam_per_time: resp.processo.exam_per_time,
                        mobile: resp.processo.mobile,

                        show_rascunho: resp.processo.show_rascunho,
                        chat_type: resp.processo.simulado == true || ((resp.processo.need_pause || resp.processo.required_camera_external) && resp.processo.chat_type === 'none') ? 'all' : resp.processo.chat_type,
                        show_fiscal_chat: resp.processo.show_fiscal_chat !== false,
                        time_save: resp.processo.save_timer,
                        fiscalizacao: resp.processo.type_fiscalization,
                        type_time: resp.processo.type_time,
                        screen_extended_retrict: resp.processo.screen_extended_retrict,
                        screen_sharing: resp.processo.screen_sharing,
                        required_camera_external: resp.processo.required_camera_external,
                        face_validation: resp.processo.face_validation,
                        allow_face_validation_skip: resp.processo.allow_face_validation_skip === true,
                        face_validation_periodicaly: resp.processo.face_validation_periodicaly,

                        is_interview: resp.processo.is_interview,
                        full_screen: resp.processo.full_screen,

                        tempo_prova: resp.processo.tempo_prova == null ? '' : (resp.processo.tempo_prova + ''),
                    });
                    // if (resp.processo != null) {


                }




            } catch (err) {
                this.setState({ redirect: true });
                console.log(err);


            }

        })
            .catch((err) => {
                this.setState({ redirect: true });

                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }



    salvar(e) {
        e.preventDefault();
        if(this.state.restrict_access==true && this.state.inicio_access.format('YYYY-MM-DD')+' '+this.state.hora_inicio_access.format('HH:mm')>this.state.inicio.format('YYYY-MM-DD')+' '+this.state.hora_inicio.format('HH:mm')){
            this.setState({  msgErro: 'A Data/hora de início deve ser maior que a Data/hora de início do intervalo de restrição de acesso' });
            window.scrollTo(500, 0);
            
            return;
        }
        if(this.state.restrict_access==true && this.state.fim_access.format('YYYY-MM-DD')+' '+this.state.hora_fim_access.format('HH:mm')>=this.state.fim.format('YYYY-MM-DD')+' '+this.state.hora_fim.format('HH:mm')){
            this.setState({  msgErro: 'A Data/hora de encerramento deve ser maior que a Data/hora de encerramento do intervalo de restrição de acesso' });
            window.scrollTo(500, 0);
            
            return;
        }

        this.setState({ loading_save: true, msgErro: '' });
        

        let data={
            name: this.state.name,
            descricao: this.state.descricao,
            code: this.state.code,

            regras: this.state.regras,
            hora_inicio: this.state.hora_inicio.format('HH:mm'),
            inicio: this.state.inicio.format('DD/MM/YYYY'),
            fim: this.state.fim.format('DD/MM/YYYY'),
            hora_fim: this.state.hora_fim.format('HH:mm'),

            hora_inicio_access: this.state.hora_inicio_access.format('HH:mm'),
            inicio_access: this.state.inicio_access.format('DD/MM/YYYY'),
            fim_access: this.state.fim_access.format('DD/MM/YYYY'),
            hora_fim_access: this.state.hora_fim_access.format('HH:mm'),

            chat_type: this.state.simulado == true ? 'all' : this.state.chat_type,
            show_fiscal_chat: this.state.show_fiscal_chat,
            chat_time: this.state.chat_time!=''?(this.state.chat_time*60):(this.state.fiscalizacao!='none'?'':3600),
            request_time: this.state.request_time!=''?(this.state.request_time*60):(this.state.face_validation?'':3600),
            time_validation_periodicaly: this.state.time_validation_periodicaly!=''?(this.state.time_validation_periodicaly):(this.state.face_validation_periodicaly?'':40),


            processo_id: this.props.match.params.id,
            type_time: this.state.type_time,
            tempo_prova: this.state.tempo_prova,
            online: this.state.online,
            full_screen:this.state.full_screen,
            screen_extended_retrict:this.state.screen_sharing==true?true: this.state.screen_extended_retrict,
            screen_sharing:this.state.screen_sharing,
            required_camera_external:this.state.fiscalizacao == 'all' && this.state.mobile == false ? this.state.required_camera_external : false,
            face_validation: this.state.face_validation,
            allow_face_validation_skip: this.state.allow_face_validation_skip,
            face_validation_periodicaly: this.state.face_validation_periodicaly,

            hora_inicio_access: this.state.hora_inicio_access.format('HH:mm'),
            inicio_access: this.state.inicio_access.format('DD/MM/YYYY'),
            fim_access: this.state.fim_access.format('DD/MM/YYYY'),
            hora_fim_access: this.state.hora_fim_access.format('HH:mm'),

        restrict_access: this.state.restrict_access,
        simulado: this.state.simulado,
        show_rascunho: this.state.show_rascunho,
        mobile: this.state.mobile,
        need_pause: this.state.need_pause,
            // exam_per_time: this.state.exam_per_time,
        }




        fetch(`${URL}api/faculdade/update_processo`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-type': 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
            },
            body: JSON.stringify(data)
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    window.scrollTo(500, 0);

                    this.setState({ loading_save: false, msgErro: erro });
                }
                else {

                    this.setState({ loading_save: false, redirect: true });

                }




            } catch (err) {
                console.log(err);
                this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor' });

            }

        })
            .catch((err) => {
                console.log(err);
                this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?' });
            });
    }


    componentDidMount() {
        this.get_processo(this.props.match.params.id);
    }



    componentWillUnmount(){
        Array.from(document.getElementsByClassName('jodit-wysiwyg')).forEach((el) => {
            // Do stuff here
            el.blur()
        })
    }

    change_tipo(event) {
        this.setState({ tipo: event.target.value });
    }


    render() {
        return (
            <div className="row">
                {this.state.redirect == true && <Redirect to={`/instituicao/show/${this.state.faculdade.id}`} />}

                <div className="col-12">
                    <ConfigurationFormLayout title={<>Editar {(this.props.user.empresa==null || this.props.user.empresa.change_text==false)?'Processo':'Vaga/Cargo'}</>} description={<>Configure os dados, o período e as opções de avaliação de {this.state.faculdade.name || 'seu seletivo'}.</>} kind="process" formId="configuration-form" backTo={`/instituicao/show/${this.state.faculdade.id}`} saveLabel={'Salvar ' + (this.props.user.empresa?.change_text ? 'vaga/cargo' : 'processo')} loading={this.state.loading_save} disabled={this.state.loading_screen || this.state.loading_image} summary={!this.state.loading_screen && <ProcessConfigurationSummary values={this.state} onlineEnabled={this.props.user.empresa?.online_proccess == true} />}>
                            {/* <hr /> */}
                            {this.state.loading_screen == false && <div>
                                {this.state.msgErro != '' && <div style={{ display: 'flex', marginBottom: 15, width: '100%' }}>
                                    <div className="alert alert-danger alert-dismissible fade show mb-0 w-100" role="alert">
                                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => this.setState({ msgErro: '' })}></button>


                                        <p style={{ marginBottom: 0 }}>{this.state.msgErro}</p>

                                    </div>
                                    <br />

                                </div>}
                                <Form id="configuration-form" onSubmit={(e) => this.salvar(e)} style={{ position: "relative" }}>
                                    <ConfigurationSection title="Identificação" description="Preencha os dados que identificam este cadastro." />
                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>Nome <Attention /> <FormFieldHelp>Nome que identifica este cadastro nas listagens e nas telas de acesso dos participantes.</FormFieldHelp></Form.Label>
                                            <Input
                                                placeholder={"Nome "+((this.props.user.empresa==null || this.props.user.empresa.change_text==false)?'do processo':'da vaga/cargo')}
                                                value={this.state.name}
                                                onChange={(e) => this.setState({ name: e.target.value })}
                                                required
                                            // title="Coloque o nome completo do usuário"
                                            />
                                        </div>
                                    </InputGroup>

                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>Descrição <Attention /> <FormFieldHelp>Apresenta informações sobre esta avaliação para identificar seu objetivo e orientar os participantes.</FormFieldHelp></Form.Label>
                                            <Input
                                                placeholder={"Descrição "+((this.props.user.empresa==null || this.props.user.empresa.change_text==false)?'do processo':'da vaga/cargo')}
                                                value={this.state.descricao}
                                                onChange={(e) => this.setState({ descricao: e.target.value })}
                                                required
                                                as="textarea"
                                            />
                                        </div>
                                    </InputGroup>
                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                        <Form.Label >Regras {(this.props.user.empresa==null || this.props.user.empresa.change_text==false)?'do processo':'da vaga/cargo'} <Attention /> {this.state.loading_image == true && <div className="spinner-border text-primary spinner-border-sm" role="status"  >
                                            </div>} <FormFieldHelp>Instruções e regras apresentadas ao candidato antes de iniciar a avaliação. Use o editor para organizar e destacar as orientações.</FormFieldHelp></Form.Label>
                                            <JoditEditor
                                                ref={this.editor}
                                                value={this.state.regras}
                                                config={this.config}
                                                height={400}
                                                tabIndex={1} // tabIndex of textarea
                                                onBlur={newContent => this.setState({ regras: newContent })} // preferred to use only this option to update the content for performance reasons
                                            // onChange={newContent => {this.setState({enunciado:newContent}) }}
                                            />
                                        </div>
                                    </InputGroup>

                                    {this.props.user?.empresa?.online_proccess==true && <InputGroup>
                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>A avaliação é online? <Attention /> <FormFieldHelp>Sim: a avaliação é realizada pelo sistema, com as opções de realização e fiscalização configuradas abaixo. Não: a avaliação é presencial, e as opções de realização online não se aplicam.</FormFieldHelp></Form.Label>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                name="radio-buttons-group"
                                                value={this.state.online}
                                                onChange={(e) => {
                                                    this.setState({ online: e.target.value });
                                                }}>

                                                <FormControlLabel onClick={(e) => {
                                                    this.setState({ online: true });
                                                }} control={<Radio checked={this.state.online == true} value={true} />} style={{ color: 'black' }} label={'Sim'} />
                                                <FormControlLabel onClick={(e) => {
                                                    console.log(e.target.value);
                                                    this.setState({ online: false });

                                                }} control={<Radio checked={this.state.online == false} value={false} />} style={{ color: 'black' }} label={'Não'} />
                                            </RadioGroup>
                                        </div>
                                    </InputGroup>}

                                    {this.props.user?.empresa?.online_proccess==true && this.state.online == true && <InputGroup>
                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>É uma avaliação oral? <Attention /> <FormFieldHelp>Se habilitado, esta vaga/cargo será uma entrevista (avaliação oral) com os candidatos vinculados a ele, onde será possível cadastrar os critérios de avaliação e quem serão os avaliadores. Cada avaliador poderá entrar em chamadas individuais com cada candidato.</FormFieldHelp></Form.Label>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                name="radio-buttons-group"
                                                value={this.state.is_interview}
                                                disabled
                                                onChange={(e) => {
                                                }}>

                                                <FormControlLabel disabled onClick={(e) => {
                                                }} control={<Radio checked={this.state.is_interview == true} value={true} />} style={{ color: 'black' }} label={'Sim'} />
                                                <FormControlLabel onClick={(e) => {
                                                    console.log(e.target.value);

                                                }} disabled control={<Radio checked={this.state.is_interview == false} value={false} />} style={{ color: 'black' }} label={'Não'} />
                                            </RadioGroup>
                                        </div>
                                    </InputGroup>}


                                    <ConfigurationSection title="Período da avaliação" description="Defina quando os candidatos poderão realizar a avaliação." />
                                    <MuiPickersUtilsProvider utils={MomentUtils}>

                                        <InputGroup>

                                            <div className="flex fdcolumn flex1 margin-bottom me-3">
                                                <Form.Label>Data de início <Attention /> <FormFieldHelp>Dia em que começa o período da avaliação. É usado junto com o horário de início para controlar sua disponibilidade.</FormFieldHelp></Form.Label>
                                                <DatePicker
                                                    autoOk
                                                    margin="normal"
                                                    style={{ width: '100%' }}
                                                    invalidDateMessage="Data inválida"
                                                    ampm={false}
                                                    minDate={moment()}
                                                    id="time-picker"
                                                    cancelLabel="Cancelar"
                                                    clearLabel="Limpar"
                                                    format="DD/MM/YYYY"
                                                    value={this.state.inicio}
                                                    onChange={(date) => { this.setState({ inicio: date }) }}

                                                />
                                            </div>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>Horário de início <Attention /> <FormFieldHelp>Horário de abertura da avaliação na data de início. As opções de chat e liberação antecipada usam esse momento como referência.</FormFieldHelp></Form.Label>
                                                <TimePicker
                                                    autoOk
                                                    margin="normal"
                                                    style={{ width: '100%' }}
                                                    invalidDateMessage="Horário inválido"
                                                    ampm={false}
                                                    id="time-picker"
                                                    cancelLabel="Cancelar"
                                                    clearLabel="Limpar"
                                                    label=""
                                                    value={this.state.hora_inicio}
                                                    onChange={(date) => { this.setState({ hora_inicio: date }) }}

                                                />
                                            </div>
                                        </InputGroup>

                                        <InputGroup>

                                            <div className="flex fdcolumn flex1 margin-bottom me-3">
                                                <Form.Label>Data de encerramento <Attention /> <FormFieldHelp>Último dia do período da avaliação. É usado junto com o horário de encerramento para definir o limite de realização.</FormFieldHelp></Form.Label>
                                                <DatePicker
                                                    autoOk
                                                    margin="normal"
                                                    style={{ width: '100%' }}
                                                    invalidDateMessage="Data inválida"
                                                    ampm={false}
                                                    minDate={moment()}
                                                    id="time-picker"
                                                    cancelLabel="Cancelar"
                                                    clearLabel="Limpar"
                                                    format="DD/MM/YYYY"
                                                    value={this.state.fim}
                                                    onChange={(date) => { this.setState({ fim: date }) }}

                                                />
                                            </div>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>Horário de encerramento <Attention /> <FormFieldHelp>Horário limite para realizar a avaliação na data de encerramento, inclusive quando houver um tempo individual de prova.</FormFieldHelp></Form.Label>
                                                <TimePicker
                                                    autoOk
                                                    margin="normal"
                                                    style={{ width: '100%' }}
                                                    invalidDateMessage="Horário inválido"
                                                    ampm={false}
                                                    id="time-picker"
                                                    cancelLabel="Cancelar"
                                                    clearLabel="Limpar"
                                                    label=""
                                                    value={this.state.hora_fim}
                                                    onChange={(date) => { this.setState({ hora_fim: date }) }}

                                                />
                                            </div>
                                        </InputGroup>


                                    </MuiPickersUtilsProvider>
                                    {this.state.online == true && <>
                                        <ConfigurationSection title="Experiência da avaliação" description="Ajuste os recursos disponíveis durante a realização da prova." />
                                        <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>É um simulado para teste de compatibilidade dos candidatos? <Attention /> <FormFieldHelp>Se habilitado, essa vaga/cargo será um teste para os candidatos conseguirem acessar o sistema e testar funções como compartilhamento de câmera/áudio/tela. Será gerado também uma prova teste dentro da vaga/cargo.</FormFieldHelp></Form.Label>
                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.simulado}
                                                    disabled
                                                    onChange={(e) => {
                                                        let data = {}
                                                        if (e.target.value == true) {
                                                            data.type_time = 'restrict';
                                                            data.tempo_prova = 4;
                                                            data.fiscalizacao = 'all';
                                                            data.chat_type = 'all';
                                                            data.exam_per_time=false;
                                                        }
                                                        else {
                                                            data.chat_type = 'all';
                                                            data.type_time = 'all';
                                                            data.tempo_prova = '';
                                                        }
                                                        return;
                                                        this.setState({ simulado: e.target.value, ...data });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        let data = {}
                                                        data.type_time = 'restrict';
                                                        data.tempo_prova = 4;
                                                        data.fiscalizacao = 'all';
                                                        data.chat_type = 'all';
                                                        data.exam_per_time=false;
                                                        return;

                                                        this.setState({ simulado: true, ...data });
                                                    }} disabled control={<Radio checked={this.state.simulado == true} value={true} />} style={{ color: 'black' }} label={'Sim'} />
                                                    <FormControlLabel onClick={(e) => {
                                                        let data = {}
                                                        data.chat_type = 'all';
                                                        data.type_time = 'all';
                                                        data.tempo_prova = '';
                                                        return;

                                                        this.setState({ simulado: false, ...data });

                                                    }} disabled control={<Radio checked={this.state.simulado == false} value={false} />} style={{ color: 'black' }} label={'Não'} />

                                                </RadioGroup>



                                            </div>
                                        </InputGroup>
                                        <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>Cada avaliação terá um tempo máximo para fazer? <Attention /> <FormFieldHelp>Se habilitado, na hora de criar a prova será obrigatório definir o tempo, em minutos, que cada questão terá para ser respondida. Caso não queira que tenha tempo por questão, desabilite-a.</FormFieldHelp></Form.Label>
                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.exam_per_time}
                                                    onChange={(e) => {
                                                        if(this.state.simulado==true){
                                                            return;
                                                        }
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        if(this.state.simulado==true){
                                                            return;
                                                        }
                                                    }} disabled control={<Radio checked={this.state.exam_per_time == true} value={true} />} style={{ color: 'black' }} label={'Sim'} />
                                                    <FormControlLabel onClick={(e) => {
                                                        if(this.state.simulado==true){
                                                            return;
                                                        }

                                                    }} disabled control={<Radio checked={this.state.exam_per_time == false} value={false} />} style={{ color: 'black' }} label={'Não'} />

                                                </RadioGroup>



                                            </div>
                                        </InputGroup>
                                        <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>O candidato poderá solicitar pausa durante a prova? <Attention /> <FormFieldHelp>Se habilitado, é exibilido um botão de "Pedir Pausa" do lado do candidato, onde ele poderá solicitar pausas durante a prova com uma justificativa, por exemplo: preciso ir ao banheiro, preciso amamentar, etc. O fiscal vinculado a sala daquele candidato deverá aceitar ou negar a pausa solicitada.</FormFieldHelp></Form.Label>

                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.need_pause}
                                                    onChange={(e) => {
                                                        
                                                        this.setState({ need_pause: e.target.value });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        
                                                        this.setState({ need_pause: true, chat_type: this.state.chat_type === 'none' ? 'all' : this.state.chat_type });
                                                    }}  control={<Radio checked={this.state.need_pause == true} value={true} />} style={{ color: 'black' }} label={'Sim'} />
                                                    <FormControlLabel onClick={(e) => {
                                                       
                                                        this.setState({ need_pause: false });

                                                    }} control={<Radio checked={this.state.need_pause == false} value={false} />} style={{ color: 'black' }} label={'Não'} />

                                                </RadioGroup>
                                            </div>
                                        </InputGroup>
                                        <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>O candidato poderá acessar por dispositivos móveis? <Attention /> <FormFieldHelp>Se habilitado, a avaliação também poderá ser realizada por dispositivos móveis, porém algumas funções não poderão ser habilitadas, sendo estas: Gravação de tela e Validação facial.</FormFieldHelp></Form.Label>

                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.mobile}
                                                    onChange={(e) => {
                                                        
                                                        // this.setState({ mobile: e.target.value });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        let data ={};
                                                        data.screen_sharing=false;
                                                        data.required_camera_external=false;
                                                        data.face_validation=false;
                                                        data.face_validation_periodicaly=false;
                                                        
                                                        this.setState({ mobile: true,...data });
                                                    }}  control={<Radio checked={this.state.mobile == true} value={true} />} style={{ color: 'black' }} label={'Sim'} />
                                                    <FormControlLabel onClick={(e) => {
                                                        this.setState({ mobile: false });

                                                    }}  control={<Radio checked={this.state.mobile == false} value={false} />} style={{ color: 'black' }} label={'Não'} />

                                                </RadioGroup>



                                            </div>
                                        </InputGroup>
                                        <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>Disponibilizar campo para rascunho em cada questão? <Attention /> <FormFieldHelp>Se habilitado, em cada questão terá um botão de rascunho para o candidato, onde será aberto um caixa de texto para o candidato escrever. O rascunho não é salvo pelo sistema.</FormFieldHelp></Form.Label>

                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.show_rascunho}
                                                    onChange={(e) => {
                                                        this.setState({ show_rascunho: e.target.value });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        this.setState({ show_rascunho: true });
                                                    }} control={<Radio checked={this.state.show_rascunho == true} value={true} />} style={{ color: 'black' }} label={'Sim'} />
                                                    <FormControlLabel onClick={(e) => {
                                                        this.setState({ show_rascunho: false });

                                                    }} control={<Radio checked={this.state.show_rascunho == false} value={false} />} style={{ color: 'black' }} label={'Não'} />

                                                </RadioGroup>



                                            </div>
                                        </InputGroup>

                                        <InputGroup>
                                        <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>Obrigar o uso de tela cheia para ver a avaliação? <Attention /> <FormFieldHelp>Se habilitado, o candidato só conseguirá fazer a avaliação com o sistema em tela cheia. Caso ele saia da tela cheia, o sistema registro como saída de tela.</FormFieldHelp></Form.Label>

                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.full_screen}
                                                    onChange={(e) => {
                                                        this.setState({ full_screen: e.target.value });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        this.setState({ full_screen: true });
                                                    }} control={<Radio checked={this.state.full_screen == true} value={true} />} style={{ color: 'black' }} label={'Sim'} />
                                                    <FormControlLabel onClick={(e) => {
                                                        this.setState({ full_screen: false });

                                                    }} control={<Radio checked={this.state.full_screen == false} value={false} />} style={{ color: 'black' }} label={'Não'} />

                                                </RadioGroup>

                                              

                                            </div>
                                        </InputGroup>
                                        <InputGroup>

                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>Tempo de prova <Attention /> <FormFieldHelp>Período completo: o candidato pode usar o tempo disponível até o encerramento da avaliação. Tempo restrito: define uma duração individual a partir do acesso, respeitando o horário de encerramento.</FormFieldHelp></Form.Label>

                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.type_time}
                                                    disabled={this.state.simulado}

                                                    onChange={(e) => {
                                                        if(this.state.simulado){
                                                            return;
                                                        }
                                                        this.setState({ type_time: e.target.value });
                                                    }}>

                                                    <FormControlLabel 
                                                    disabled={this.state.simulado}
                                                    
                                                    onClick={(e) => {
                                                        if(this.state.simulado){
                                                            return;
                                                        }
                                                        this.setState({ type_time: 'all' });
                                                    }} control={<Radio checked={this.state.type_time == 'all'} value={'all'} />} style={{ color: 'black' }} label={'Candidato pode usar o tempo total de prova'} />
                                                    <FormControlLabel 
                                                    disabled={this.state.simulado}
                                                    
                                                    onClick={(e) => {
                                                        if(this.state.simulado){
                                                            return;
                                                        }
                                                        this.setState({ type_time: 'restrict' });

                                                    }} control={<Radio checked={this.state.type_time == 'restrict'} value={'restrict'} />} style={{ color: 'black' }} label={'Candidato tem um tempo de prova restrito a partir do acesso'} />

                                                </RadioGroup>

                                                {this.state.type_time == 'restrict' && <>
                                                    <Form.Label>Tempo de prova em minutos <Attention /> <FormFieldHelp>Duração individual contada a partir do acesso do candidato. O encerramento geral da avaliação continua sendo o limite, mesmo que ainda reste tempo individual.</FormFieldHelp></Form.Label>
                                                    <Input
                                                    disabled={this.state.simulado}
                                                    min={1}

                                                        placeholder="Tempo de prova em minutos que o candidato terá após o primeiro acesso"
                                                        value={this.state.tempo_prova}
                                                        onChange={(e) => this.setState({ tempo_prova: e.target.value })}
                                                        required
                                                        type='number'
                                                    // title="Coloque o nome completo do usuário"
                                                    />
                                                </>}


                                            </div>


                                        </InputGroup>
                                        {<InputGroup>
                                            <ConfigurationSection title="Fiscalização e comunicação" description="Configure como acompanhar os candidatos e disponibilizar o chat." />
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>Tipo de Fiscalização <Attention /> <FormFieldHelp>Vídeo e imagem: salva os dois e permite streaming ao vivo. Apenas imagem: salva imagens e permite streaming ao vivo. Apenas logs: registra as ações sem streaming de câmera e áudio.</FormFieldHelp></Form.Label>
                                                <select disabled className="form-select " onChange={(e) => {
                                                    // let chat_type = this.state.chat_type;
                                                    // let time_save = this.state.time_save;

                                                    // if (e.target.value == 'all') {
                                                    //     chat_type = 'all';
                                                    //     time_save = '30000';
                                                    // }
                                                    // else if (e.target.value == 'image') {
                                                    //     // chat_type='all';
                                                    //     // time_save='30000';
                                                    // }
                                                    // else if (e.target.value == 'none') {
                                                    //     chat_type = 'all';
                                                    //     time_save = '30000';
                                                    // }
                                                    // this.setState({ fiscalizacao: e.target.value, chat_type, time_save,face_validation:false,face_validation_periodicaly:false })
                                                }} value={this.state.fiscalizacao}>
                                                    {(this.state.simulado==false && this.state.fiscalizacoes && this.state.fiscalizacoes.length != 0) && this.state.fiscalizacoes.map((value, index) => (
                                                        <option
                                                            key={index}
                                                            value={value["id"]}
                                                        >{value["name"]}</option>
                                                    ))}
                                                    {(this.state.simulado==true && this.state.fiscalizacoes_simulado && this.state.fiscalizacoes_simulado.length != 0) && this.state.fiscalizacoes_simulado.map((value, index) => (
                                                        <option
                                                            key={index}
                                                            value={value["id"]}
                                                        >{value["name"]}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </InputGroup>}
                                        {this.state.fiscalizacao != 'none' && this.state.simulado != true && <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>Tipo de Chat <Attention /> <FormFieldHelp>Ambos enviam mensagem: candidato e fiscal podem conversar. Apenas o fiscal envia: o candidato recebe mensagens, mas não envia. Nenhum: indicado para avaliações sem fiscal, câmera externa ou pausa. Para ocultar apenas o chat do candidato, desative Exibir chat do fiscal para o candidato.</FormFieldHelp></Form.Label>
                                                <select className="form-select " onChange={(e) => {

                                                    this.setState({ chat_type: e.target.value })
                                                }} value={this.state.chat_type}>
                                                    {(this.state.chat_types && this.state.chat_types.length != 0) && this.state.chat_types.map((value, index) => (
                                                        <option
                                                            key={index}
                                                            value={value["id"]}
                                                            disabled={value.id === 'none' && (this.state.need_pause == true || this.state.required_camera_external == true)}
                                                        >{value["name"]}</option>
                                                    ))}
                                                </select>
                                                {(this.state.need_pause == true || this.state.required_camera_external == true) && <p className="form-text mb-0">A opção Nenhum fica indisponível se pausa ou câmera externa estiverem habilitadas.</p>}
                                            </div>
                                        </InputGroup>}
                                        {this.state.fiscalizacao != 'none' && this.state.simulado != true && <InputGroup>
                                            <FiscalChatVisibility value={this.state.show_fiscal_chat} onChange={value => this.setState({ show_fiscal_chat: value })} />
                                        </InputGroup>}
                                        {this.state.simulado != true && this.state.chat_type === 'none' && <div role="note" className="d-flex align-items-start mb-3 hidethis" style={{ gap: 10, padding: '12px 14px', borderRadius: 8, border: '1px solid #f4d77e', background: '#fff8e6', color: '#775a13', width: '100%' }}>
                                            <MdInfoOutline size={22} style={{ flexShrink: 0 }} />
                                            <span>O tipo de chat <strong>Nenhum</strong> deve ser utilizado apenas em <strong>provas sem fiscal</strong>.</span>
                                        </div>}


                                        {this.state.fiscalizacao!='none'  &&<InputGroup>
                                            <div className="margin-bottom">
                                             <>
                                                    <Form.Label>Tempo em minuntos anterior a avaliação que deve aparecer para o candidato o chat de comunicação com o fiscal <Attention /> <FormFieldHelp>Exemplo: Caso seja colocado 60 minutos, então uma hora antes do início da avaliação aparecerá para o candidato o chat de comunicação onde é possível enviar e receber mensagens dos fiscais.</FormFieldHelp></Form.Label>
                                                    
                                                    <Input
                                                        placeholder="Tempo em minuntos anterior a avaliação que deve aparecer para o candidato o chat de comunicação com o fiscal"
                                                        value={this.state.chat_time}
                                                        min={1}
                                                        onChange={(e) => this.setState({ chat_time: e.target.value })}
                                                        required
                                                        type='number'
                                                    // title="Coloque o nome completo do usuário"
                                                    />
                                                </>
                                            </div></InputGroup>}

                                        {/* {this.state.fiscalizacao == 'image' && <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>Gerar imagem do candidato a cada <Attention /></Form.Label>
                                                <select disabled className="form-select " onChange={(e) => {
                                                    this.setState({ time_save: e.target.value })
                                                }} value={this.state.time_save}>
                                                    {(this.state.times_save && this.state.times_save.length != 0) && this.state.times_save.map((value, index) => (
                                                        <option
                                                            key={index}
                                                            value={value["id"]}
                                                        >{value["name"]}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </InputGroup>} */}


                                        <InputGroup>
                                        <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>Bloquear uso de duas ou mais telas extendidas? <Attention /> <FormFieldHelp>Sim: impede a avaliação com duas ou mais telas estendidas. Não: não aplica esse bloqueio. Ao exigir compartilhamento de tela, o bloqueio é mantido habilitado.</FormFieldHelp></Form.Label>

                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.screen_extended_retrict}
                                                    onChange={(e) => {
                                                        // this.setState({ screen_extended_retrict: e.target.value });
                                                    }}>
<FormControlLabel onClick={(e) => {
                                                        if(this.state.screen_sharing==true){
                                                            return;
                                                        }
                                                        this.setState({ screen_extended_retrict: true });
                                                    }} disabled={this.state.screen_sharing == true} control={<Radio checked={this.state.screen_extended_retrict == true} value={true} />} style={{ color: 'black' }} label={'Sim'} />
                                                    <FormControlLabel onClick={(e) => {
                                                         if(this.state.screen_sharing==true){
                                                            return;
                                                        }
                                                        this.setState({ screen_extended_retrict: false });

                                                    }} disabled={this.state.screen_sharing == true} control={<Radio checked={this.state.screen_extended_retrict == false} value={false} />} style={{ color: 'black' }} label={'Não'} />

                                                </RadioGroup>

                                              

                                            </div>
                                        </InputGroup>

                                        {this.state.fiscalizacao == 'all' && this.state.mobile==false && <InputGroup>
                                            <ConfigurationSection title="Validação e segurança" description="Escolha as verificações necessárias para acessar e realizar a avaliação." />
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{this.state.simulado == true ? 'Obrigar compartilhamento de tela para o teste? (Simula a gravação de tela para caso for usar em uma prova real)' : 'Gravar a tela do candidato? (Exige compartilhamento de tela)'} <Attention /> <FormFieldHelp>Quando habilitado, exige compartilhar a tela para realizar a avaliação e permite gravá-la. No simulado, testa o compartilhamento da tela para verificar a compatibilidade. Quando desabilitado, não exige esse compartilhamento.</FormFieldHelp></Form.Label>
                                            <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.screen_sharing}
                                                    onChange={(e) => {
                                                        // this.setState({ screen_sharing: e.target.value });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        if(this.state.mobile==true){
                                                            return;
                                                        }
                                                        this.setState({ screen_sharing: true, screen_extended_retrict: true });
                                                    }} disabled={this.state.mobile} control={<Radio checked={this.state.screen_sharing == true} value={true} />} style={{ color: 'black' }} label={'Sim'} />
                                                    <FormControlLabel onClick={(e) => {
                                                        if(this.state.mobile==true){
                                                            return;
                                                        }
                                                        this.setState({ screen_sharing: false });

                                                    }} disabled={this.state.mobile} control={<Radio checked={this.state.screen_sharing == false} value={false} />} style={{ color: 'black' }} label={'Não'} />

                                                </RadioGroup>
                                            </div>
                                            
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{'Usar inteligência artificial para ter validação facial e microfone na entrada?'} <Attention /> <FormFieldHelp>Se habilitada o candidato só conseguirá acessar a prova caso tenha sido identificado um rosto (apenas um) na imagem de sua câmera, e será necessário ele fazer movimentos para a esquerda e direita com a cabeça para validar sua entrada. Será necessário o candidato falar uma frase para ser validado o microfone.</FormFieldHelp></Form.Label>
                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.face_validation}
                                                    onChange={(e) => {
                                                        // this.setState({ screen_sharing: e.target.value });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        if(this.state.mobile==true){
                                                            return;
                                                        }
                                                        this.setState({ face_validation: true });
                                                    }} disabled={this.state.mobile} control={<Radio checked={this.state.face_validation == true} value={true} />} style={{ color: 'black' }} label={'Sim'} />
                                                    <FormControlLabel onClick={(e) => {
                                                        if(this.state.mobile==true){
                                                            return;
                                                        }
                                                        this.setState({ face_validation: false });

                                                    }} disabled={this.state.mobile} control={<Radio checked={this.state.face_validation == false} value={false} />} style={{ color: 'black' }} label={'Não'} />

                                                </RadioGroup>
                                            </div>
                                        </InputGroup>}

                                        {this.state.fiscalizacao == 'all' && this.state.mobile==false && <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom" style={{ marginTop: 10 }}>
                                                <Form.Label>Obrigar câmera externa do candidato? <Attention /> <FormFieldHelp>Se habilitada, o candidato só conseguirá visualizar e acessar a avaliação quando a câmera externa estiver conectada pelo celular.</FormFieldHelp></Form.Label>
                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.required_camera_external}
                                                    onChange={(e) => {
                                                        // this.setState({ required_camera_external: e.target.value });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        this.setState({ required_camera_external: true, chat_type: this.state.chat_type === 'none' ? 'all' : this.state.chat_type });
                                                    }} control={<Radio checked={this.state.required_camera_external == true} value={true} />} style={{ color: 'black' }} label={'Sim'} />
                                                    <FormControlLabel onClick={(e) => {
                                                        this.setState({ required_camera_external: false });

                                                    }} control={<Radio checked={this.state.required_camera_external == false} value={false} />} style={{ color: 'black' }} label={'Não'} />

                                                </RadioGroup>
                                            </div>
                                        </InputGroup>}
                                        {this.state.fiscalizacao == 'all' && this.state.mobile==false && this.state.face_validation==true && <InputGroup>

                                            <FaceValidationReleaseSettings
                                                allowContinue={this.state.allow_face_validation_skip}
                                                onAllowContinue={value => this.setState({ allow_face_validation_skip: value })}
                                                minutes={this.state.request_time}
                                                onMinutesChange={value => this.setState({ request_time: value })}
                                                chatType={this.state.chat_type}
                                            />
                                            {this.state.face_validation==true && <div className="margin-bottom" style={{marginLeft:0,marginRight:0,paddingLeft:0,paddingRight:0}}>
                                                <Form.Label>{'Realizar validação facial e de microfone caso não detectado durante a avaliação?'} <Attention /> <FormFieldHelp>Se habilitada, caso após o candidato acessar a avaliação não ser detecado um rosto na câmera ou oscilação de áudio no microfone por um determinado tempo, o candidato deverá realizar a validação novamente (Apenas se o candidato não tenha sido liberado pelo fiscal).</FormFieldHelp></Form.Label>
                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.face_validation_periodicaly}
                                                    onChange={(e) => {
                                                        // this.setState({ screen_sharing: e.target.value });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        if(this.state.mobile==true){
                                                            return;
                                                        }
                                                        this.setState({ face_validation_periodicaly: true });
                                                    }} disabled={this.state.mobile} control={<Radio checked={this.state.face_validation_periodicaly == true} value={true} />} style={{ color: 'black' }} label={'Sim'} />
                                                    <FormControlLabel onClick={(e) => {
                                                        if(this.state.mobile==true){
                                                            return;
                                                        }
                                                        this.setState({ face_validation_periodicaly: false });

                                                    }} disabled={this.state.mobile} control={<Radio checked={this.state.face_validation_periodicaly == false} value={false} />} style={{ color: 'black' }} label={'Não'} />

                                                </RadioGroup>
                                                {this.state.face_validation_periodicaly  && <>
                                                    <Form.Label>Tempo sem reconhecimento para o candidato ter que realizar a validação facial novamente (Em segundos) <Attention /> <FormFieldHelp>Quantidade de segundos sem detectar rosto ou oscilação de áudio para exigir uma nova validação durante a avaliação. O valor mínimo permitido neste formulário é de 20 segundos.</FormFieldHelp></Form.Label>
                                                    <Input
                                                        placeholder="Tempo sem reconhecimento para o candidato ter que realizar a validação facial novamente (Em segundos)"
                                                        value={this.state.time_validation_periodicaly}
                                                        onChange={(e) => this.setState({ time_validation_periodicaly: e.target.value })}
                                                        required
                                                        min={20}
                                                        type='number'
                                                    // title="Coloque o nome completo do usuário"
                                                    />
                                                </>}
                                            </div>}
                                        </InputGroup>}

                                        <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>Restringir horário de acesso do candidato? <Attention /> <FormFieldHelp>Candidatos que não tiverem acessado o sistema dentro de um determinado horário, não conseguiram acessar a prova</FormFieldHelp></Form.Label>
                                                 <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.restrict_access}
                                                    onChange={(e) => {
                                                        this.setState({ restrict_access: e.target.value });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        this.setState({ restrict_access: true });
                                                    }} control={<Radio checked={this.state.restrict_access == true} value={true} />} style={{ color: 'black' }} label={'Sim'} />
                                                    <FormControlLabel onClick={(e) => {
                                                        this.setState({ restrict_access: false });

                                                    }} control={<Radio checked={this.state.restrict_access == false} value={false} />} style={{ color: 'black' }} label={'Não'} />

                                                </RadioGroup>
                                            </div>
                                        </InputGroup>

                                        {this.state.restrict_access==true && <MuiPickersUtilsProvider utils={MomentUtils}>

                                        <InputGroup>

                                            <div className="flex fdcolumn flex1 margin-bottom me-3">
                                                <Form.Label>Data inicial do intervalo <Attention /> <FormFieldHelp>Primeiro dia do intervalo permitido para o acesso do candidato quando a restrição de horário estiver habilitada.</FormFieldHelp></Form.Label>
                                                <DatePicker
                                                    autoOk
                                                    margin="normal"
                                                    style={{ width: '100%' }}
                                                    invalidDateMessage="Data inválida"
                                                    ampm={false}
                                                    id="time-picker"
                                                    cancelLabel="Cancelar"
                                                    clearLabel="Limpar"
                                                    format="DD/MM/YYYY"
                                                    value={this.state.inicio_access}
                                                    onChange={(date) => { this.setState({ inicio_access: date }) }}

                                                />
                                            </div>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>Horário inicial do intervalo <Attention /> <FormFieldHelp>Horário a partir do qual o candidato pode acessar a avaliação, na data inicial do intervalo.</FormFieldHelp></Form.Label>
                                                <TimePicker
                                                    autoOk
                                                    margin="normal"
                                                    style={{ width: '100%' }}
                                                    invalidDateMessage="Horário inválido"
                                                    ampm={false}
                                                    id="time-picker"
                                                    cancelLabel="Cancelar"
                                                    clearLabel="Limpar"
                                                    label=""
                                                    value={this.state.hora_inicio_access}
                                                    onChange={(date) => { this.setState({ hora_inicio_access: date }) }}

                                                />
                                            </div>
                                        </InputGroup>

                                        <InputGroup>

                                            <div className="flex fdcolumn flex1 margin-bottom me-3">
                                                <Form.Label>Data de encerramento do intervalo <Attention /> <FormFieldHelp>Último dia em que o candidato pode acessar a avaliação dentro do intervalo restrito.</FormFieldHelp></Form.Label>
                                                <DatePicker
                                                    autoOk
                                                    margin="normal"
                                                    style={{ width: '100%' }}
                                                    invalidDateMessage="Data inválida"
                                                    ampm={false}
                                                    id="time-picker"
                                                    cancelLabel="Cancelar"
                                                    clearLabel="Limpar"
                                                    format="DD/MM/YYYY"
                                                    value={this.state.fim_access}
                                                    onChange={(date) => { this.setState({ fim_access: date }) }}

                                                />
                                            </div>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>Horário de encerramento do intervalo <Attention /> <FormFieldHelp>Limite de horário para o acesso do candidato na data final do intervalo. Essa configuração restringe a entrada; o encerramento da avaliação é definido no período geral.</FormFieldHelp></Form.Label>
                                                <TimePicker
                                                    autoOk
                                                    margin="normal"
                                                    style={{ width: '100%' }}
                                                    invalidDateMessage="Horário inválido"
                                                    ampm={false}
                                                    id="time-picker"
                                                    cancelLabel="Cancelar"
                                                    clearLabel="Limpar"
                                                    label=""
                                                    value={this.state.hora_fim_access}
                                                    onChange={(date) => { this.setState({ hora_fim_access: date }) }}

                                                />
                                            </div>
                                        </InputGroup>



                                    </MuiPickersUtilsProvider>}

                                    </>}
                                </Form>

                            </div>}

                            {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                                <div className="spinner-border text-primary" role="status"  >
                                </div>
                            </div></div>}


                    </ConfigurationFormLayout>
                </div>
            </div >
        );
    }


}
const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        user: state.AppReducer.user,
    }
);

export default connect(mapsStateToProps, { logout })(EditarProcesso);
